import { create } from "zustand";

export const usePermission = create()((set) => ({
  permission: true,
  setPermission: (permission: boolean) => {
    return set({ permission });
  },
}));

export const setPermission = (permission: boolean) => {
  return usePermission.setState({
    permission,
  });
};
